import React from 'react';
import { Navigate, Route } from 'react-router-dom';
import Homepage from '../components/Homepage';
import Contact from '../components/Contact';
import { AUTH_PATHS, DEFAULT_PATHS, MARKETING_PATHS } from './paths.ts';

interface MarketingRoutesProps {
  user: unknown;
  RedirectToAppPublic: React.ComponentType<{ path: string }>;
}

export function renderMarketingRoutes({
  user,
  RedirectToAppPublic,
}: MarketingRoutesProps): React.ReactNode {
  return (
    <>
      <Route
        path={MARKETING_PATHS.ROOT}
        element={
          user ? <Navigate to={DEFAULT_PATHS.TENANT_LANDING} replace /> : <Homepage />
        }
      />
      <Route path={MARKETING_PATHS.CONTACT} element={<Contact />} />
      <Route
        path={MARKETING_PATHS.HOME}
        element={
          user ? (
            <Navigate to={DEFAULT_PATHS.TENANT_LANDING} replace />
          ) : (
            <RedirectToAppPublic path={AUTH_PATHS.SIGNIN} />
          )
        }
      />
    </>
  );
}
